// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"188":"bde437ee","408":"9b1018ea","427":"4d67ad73","712":"f041a7b7","736":"bc93d822","899":"1c142249","985":"b1dbd8e9"}[chunkId] + ".chunk.js";
};